import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const removeContact = (body) =>
  swRequest({
    path: "/api/extension/remove_contact",
    method: "POST",
    body,
  });

export const getCompanyInsights = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/extension/company_insights",
      method: "POST",
      body,
    },
    opts,
  );

export const downvoteCompanyInsights = (body, opts = {}) =>
  swRequest(
    {
      path: "/api/extension/downvote_insights",
      method: "POST",
      body,
    },
    opts,
  );
